import {Component, ElementRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {
  CartLineQuantitySetterViewModel
} from "@app/presentation/components/cart-line-quantity-setter/cart-line-quantity-setter.view-model";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {
  AddToCartBottomSheetComponent
} from "@app/presentation/components/cart-line-quantity-setter/add-to-cart-bottom-sheet/add-to-cart-bottom-sheet.component";
import {routesNames} from "@app/app-routing.module";
import {take, tap} from "rxjs/operators";
import {Overlay} from "@angular/cdk/overlay";
import {Product} from '@app/core/product/domain/dtos/product';
import {CartLine} from "@app/core/cart/domain/dtos/cart-line";
import {buttonSize} from "@app/presentation/components/button/button.component";
import {PopupDispatcher} from '../errors/popup.dispatcher';
import {NoStockService} from '@app/presentation/services/no-stock/no-stock.service';
import {LocalizedRouter} from "@app/presentation/services/localized-router";

@Component({
  selector: 'ep-cart-line-quantity-setter',
  templateUrl: './cart-line-quantity-setter.component.html',
  styleUrls: ['./cart-line-quantity-setter.component.scss'],
  providers: [CartLineQuantitySetterViewModel]
})
export class CartLineQuantitySetterComponent implements OnChanges {

  @Input() product?: Product | CartLine;

  @Input() promotionCode?: string | null = null;

  @Input() size: buttonSize = 'small';

  @Input() showPrice: boolean = false;

  private cartLineQuantity = 0;

  cartLineQuantity$ = this.viewModel.cartLineQuantity$.pipe(
    tap(quantity => this.cartLineQuantity = quantity)
  );

  //Display controllers

  canDisplayAddButton$ = this.viewModel.canDisplayAddButton$;

  canDisplaySeePrice$ = this.viewModel.canDisplaySeePrice$;

  canDisplayQuantitySetter$ = this.viewModel.canDisplayQuantitySetter$;

  canChangeQuantity$ = this.viewModel.canChangeQuantity$;

  dropdownIsOpen: boolean = false;

  isMobile$ = this.viewModel.isMobile$;

  isLoading$ = this.viewModel.isSetQuantityLoading$;

  public overlayPosition = this.overlay
    .position()
    .flexibleConnectedTo(this.elementRef)
    .withPositions([
      {
        originX: "end",
        originY: "top",
        overlayX: "end",
        overlayY: "top",
      }
    ]);

  constructor(
    private viewModel: CartLineQuantitySetterViewModel,
    private popupDispatcher: PopupDispatcher,
    private bottomSheet: MatBottomSheet,
    private localizedRouter: LocalizedRouter,
    private overlay: Overlay,
    private elementRef: ElementRef<HTMLElement>,
    private notEnoughStockService: NoStockService
  ) {
    this.popupDispatcher.setNotifier(viewModel.notifier);
    this.viewModel.notEnoughStock$.subscribe({
      next: products => {
        this.notEnoughStockService.display(products);
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.product) {
      this.viewModel.setProductCode(this.product.code);
    }
    if (this.promotionCode) {
      this.viewModel.setPromotionCode(this.promotionCode);
    }
  }

  onClickSeePrice() {
    this.localizedRouter.navigate(['/', routesNames.login])
  }

  onClickAddButton() {
    this.addToCart();
  }

  onClickQuantitySetter() {
    this.openQuantitySelector();
  }

  private openQuantitySelector() {
    this.isMobile$.pipe(take(1)).subscribe({
      next: isMobile => {
        if (isMobile) {
          this.openBottomSheet();
        } else {
          this.toggleDropDown();
        }
      }
    })
  }

  private openBottomSheet() {
    const bottomSheetRef = this.bottomSheet.open(
      AddToCartBottomSheetComponent,
      {
        panelClass: 'add-to-cart-bottom-sheet',
        data: { initialValue: this.cartLineQuantity }
      }
    );
    bottomSheetRef.afterDismissed().pipe(take(1)).subscribe({
      next: quantity => {
        if (quantity == null && quantity == undefined) { return; }
        this.changeQuantity(quantity);
      }
    });
  }

  private toggleDropDown() {
    this.dropdownIsOpen = !this.dropdownIsOpen;
  }

  private addToCart() {
    if (!this.product) {
      return
    }
    this.viewModel.addToCart(this.product)
  }

  changeQuantity(quantity: number) {
    if (this.product) {
      this.viewModel.setQuantity(this.product, quantity)
    }
  }

  onClickDropdown() {
    this.toggleDropDown();
  }
}
